import { CSSProperties, useEffect, useRef } from "react";

import { SemanticICONS } from "semantic-ui-react";

import TimeComboBox from "./TimeComboBox";

type TimeComboBoxStaticProps = {
  id?: string;
  style?: CSSProperties;
  disabled?: boolean;
  fluid?: boolean;
  icon?: SemanticICONS;
  inputStyle?: CSSProperties;
  interval?: number;
  maxHour?: number;
  minHour?: number;
  noMinWidth?: boolean;
  placeholder?: string;
  value?: string;
  onTextChange?: (time: string) => void;
};

const TimeComboBoxStatic = (props: TimeComboBoxStaticProps) => {
  const { value, onTextChange, ...restProps } = props;

  const innerRef = useRef<any>(null);

  // Sync value กับ TimeComboBox เมื่อ value เปลี่ยน
  if (innerRef.current && value !== undefined) {
    innerRef.current.setValue(value);
  }

  return (
    <TimeComboBox
      ref={innerRef}
      defaultValue={value}
      disableReorder
      useStaticMinute
      onTextChange={onTextChange}
      {...restProps}
    />
  );
};

TimeComboBoxStatic.displayName = "TimeComboBoxStatic";

export default TimeComboBoxStatic;
